import { Container } from "react-bootstrap";
import { Row, Col, Form, Select } from "antd";

// import Button from "antd-button-color";

import { productLists } from "data/product";

import "./style.css";
import Pagination from "components/Pagination";
import CardProduct from "components/Card/Product";
import SidebarContainer from "components/Products/Sidebar";

const sortList = ["Paling Sesuai", "Terbaru", "Harga Tertinggi", "Harga Terendah"];

const ProductContainer = () => {
  return (
    <>
      <Container className="pt-4 pb-2 d-none d-lg-block">
        <Row align="middle" justify="space-between">
          <Col>
            <span className="text-secondary fs-14-s">
              Hasil pencarian dari &quot;
              <span className="text-dark">Semua</span>&quot;
            </span>
          </Col>

          <Col>
            <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
              <Form.Item
                label={<span className="text-secondary fs-14-s">Urutkan</span>}
                name="sort"
                className="mb-0"
              >
                <Select
                  style={{ width: 150 }}
                  defaultValue="Paling Sesuai"
                  dropdownClassName="z-idx-1020"
                  getPopupContainer={(triggerNode) => triggerNode.parentElement}
                >
                  {sortList.map((sort) => (
                    <Select.Option key={sort} value={sort}>
                      {sort}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Container>

      <hr className="d-none d-lg-block" />

      <Container className="pb-5 pt-3">
        <Row gutter={[24, 14]}>
          <Col xs={0} sm={0} md={0} lg={0} span={5} className="d-none d-lg-block">
            <SidebarContainer />
          </Col>
          <Col xs={24} sm={24} md={24} lg={19} xl={19} xxl={19}>
            <Row gutter={[14, 14]}>
              {productLists.map((product) => (
                <Col xxl={4} xl={6} lg={6} md={6} sm={8} xs={12} key={product.name}>
                  <CardProduct product={product} />
                </Col>
              ))}
            </Row>

            <Row gutter={[14, 14]} className="mt-5">
              <Col span={24}>
                <Pagination
                  total={60}
                  current={1}
                  pageSize={10}
                  hideOnSinglePage
                  className="text-center"
                  goTo={() => {}}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ProductContainer;
